module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-reverse-mono.5cc2d972ea33ff58.svg";